import axios from 'axios';
import { API } from '../constants';

interface LoginResponse {
    refresh: string;
    access: string;
    user: {
        id: number;
        username: string;
        email: string;
        first_name: string;
        last_name: string;
        role: string;
        phone_number: string;
        profile_picture_url: string;
    };
}

export const authService = {

    async login(username: string, password: string): Promise<LoginResponse> {
        try {
            const response = await axios.post<LoginResponse>(`${API.BASE_URL.DEVELOPMENT}/auth/login/`, {
                username,
                password
            });
            return response.data;
        } catch (error: any) {
            if (axios.isAxiosError(error)) {

                if (error.response?.status === 401) {
                    throw new Error('Credenciales incorrectas. Por favor, verifique su usuario y contraseña.');
                } else if (error.response?.status === 403) {
                    throw new Error('Su cuenta no tiene permisos para acceder al sistema.');
                } else if (error.response?.status === 429) {
                    throw new Error('Demasiados intentos de inicio de sesión. Intente nuevamente más tarde.');
                } else {
                    throw new Error(error.response?.data?.detail || 'Error de conexión con el servidor.');
                }
            }

            throw new Error('Error inesperado. Por favor, intente nuevamente.');
        }
    },

    async logout(refreshToken: string) {
        try {
            await axios.post(`${API.BASE_URL.DEVELOPMENT}/auth/logout/`, {
                refresh: refreshToken
            });

            return true;
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
            return false;
        } finally {
            this.clearAuthData();
        }
    },

    saveAuthData(data: LoginResponse): void {
        localStorage.setItem('token', data.access);
        localStorage.setItem('refreshToken', data.refresh);
        localStorage.setItem('user', JSON.stringify(data.user));
    },


    getAuthData(): { token: string | null, user: any | null } {
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        const user = userStr ? JSON.parse(userStr) : null;
        return { token, user };
    },

    clearAuthData() {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
    }
};